export default [
  { label: 'Alabama', value: 'AL', zipCodeBoundaries: [[35000, 36999]] },
  { label: 'Alaska', value: 'AK', zipCodeBoundaries: [[99500, 99999]] },
  { label: 'Arizona', value: 'AZ', zipCodeBoundaries: [[85000, 86999]] },
  { label: 'Arkansas', value: 'AR', zipCodeBoundaries: [[71600, 72999]] },
  { label: 'California', value: 'CA', zipCodeBoundaries: [[90000, 96699]] },
  { label: 'Colorado', value: 'CO', zipCodeBoundaries: [[80000, 81999]] },
  { label: 'Connecticut', value: 'CT', zipCodeBoundaries: [[6000, 6999]] },
  { label: 'Delaware', value: 'DE', zipCodeBoundaries: [[19700, 19999]] },
  { label: 'Florida', value: 'FL', zipCodeBoundaries: [[32000, 34999]] },
  { label: 'Georgia', value: 'GA', zipCodeBoundaries: [[30000, 31999]] },
  { label: 'Hawaii', value: 'HI', zipCodeBoundaries: [[96700, 96999]] },
  { label: 'Idaho', value: 'ID', zipCodeBoundaries: [[83200, 83999]] },
  { label: 'Illinois', value: 'IL', zipCodeBoundaries: [[60000, 62999]] },
  { label: 'Indiana', value: 'IN', zipCodeBoundaries: [[46000, 47999]] },
  { label: 'Iowa', value: 'IA', zipCodeBoundaries: [[50000, 52999]] },
  { label: 'Kansas', value: 'KS', zipCodeBoundaries: [[66000, 67999]] },
  { label: 'Kentucky', value: 'KY', zipCodeBoundaries: [[40000, 42999]] },
  { label: 'Louisiana', value: 'LA', zipCodeBoundaries: [[70000, 71599]] },
  { label: 'Maine', value: 'ME', zipCodeBoundaries: [[3900, 4999]] },
  { label: 'Maryland', value: 'MD', zipCodeBoundaries: [[20600, 21999]] },
  { label: 'Massachusetts', value: 'MA', zipCodeBoundaries: [[1000, 2799]] },
  { label: 'Michigan', value: 'MI', zipCodeBoundaries: [[48000, 49999]] },
  { label: 'Minnesota', value: 'MN', zipCodeBoundaries: [[55000, 56999]] },
  { label: 'Mississippi', value: 'MS', zipCodeBoundaries: [[38600, 39999]] },
  { label: 'Missouri', value: 'MO', zipCodeBoundaries: [[63000, 65999]] },
  { label: 'Montana', value: 'MT', zipCodeBoundaries: [[59000, 59999]] },
  { label: 'Nebraska', value: 'NE', zipCodeBoundaries: [[68000, 69999]] },
  { label: 'Nevada', value: 'NV', zipCodeBoundaries: [[88900, 89999]] },
  { label: 'New Hampshire', value: 'NH', zipCodeBoundaries: [[3000, 3899]] },
  { label: 'New Jersey', value: 'NJ', zipCodeBoundaries: [[7000, 8999]] },
  { label: 'New Mexico', value: 'NM', zipCodeBoundaries: [[87000, 88499]] },
  { label: 'New York', value: 'NY', zipCodeBoundaries: [[10000, 14999]] },
  { label: 'North Carolina', value: 'NC', zipCodeBoundaries: [[27000, 28999]] },
  { label: 'North Dakota', value: 'ND', zipCodeBoundaries: [[58000, 58999]] },
  { label: 'Ohio', value: 'OH', zipCodeBoundaries: [[43000, 45999]] },
  { label: 'Oklahoma', value: 'OK', zipCodeBoundaries: [[73000, 74999]] },
  { label: 'Oregon', value: 'OR', zipCodeBoundaries: [[97000, 97999]] },
  { label: 'Pennsylvania', value: 'PA', zipCodeBoundaries: [[15000, 19699]] },
  { label: 'Puerto Rico', value: 'PR', zipCodeBoundaries: [[300, 999]] },
  { label: 'Rhode Island', value: 'RI', zipCodeBoundaries: [[2800, 2999]] },
  { label: 'South Carolina', value: 'SC', zipCodeBoundaries: [[29000, 29999]] },
  { label: 'South Dakota', value: 'SD', zipCodeBoundaries: [[57000, 57999]] },
  { label: 'Tennessee', value: 'TN', zipCodeBoundaries: [[37000, 38599]] },
  {
    label: 'Texas',
    value: 'TX',
    zipCodeBoundaries: [
      [75000, 79999],
      [88500, 88599],
    ],
  },
  { label: 'Utah', value: 'UT', zipCodeBoundaries: [[84000, 84999]] },
  { label: 'Vermont', value: 'VT', zipCodeBoundaries: [[5000, 5999]] },
  { label: 'Virginia', value: 'VA', zipCodeBoundaries: [[22000, 24699]] },
  { label: 'Washington', value: 'WA', zipCodeBoundaries: [[98000, 99499]] },
  { label: 'Washington DC', value: 'DC', zipCodeBoundaries: [[20000, 20599]] },
  { label: 'West Virginia', value: 'WV', zipCodeBoundaries: [[24700, 26999]] },
  { label: 'Wisconsin', value: 'WI', zipCodeBoundaries: [[53000, 54999]] },
  { label: 'Wyoming', value: 'WY', zipCodeBoundaries: [[82000, 83199]] },
];
